import { createFileRoute } from '@tanstack/react-router';

import { ContractsPage } from '@contracts';

export const Route = createFileRoute('/_app/os/contracts')({
  component: ContractsPage,
  errorComponent: ContractsPage.Error,
});
